import { render, staticRenderFns } from "./AdditionalServicesFormDialog.vue?vue&type=template&id=28238a55&scoped=true&lang=pug&"
import script from "./AdditionalServicesFormDialog.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServicesFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalServicesFormDialog.vue?vue&type=style&index=0&id=28238a55&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28238a55",
  null
  
)

export default component.exports